export enum AnalyticTab {
    DialogStats,
    Statistic,
    Monitoring,
    Reports
}